(() => {

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec9e7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec9e7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7M0iY", function(module, exports) {
const $5a8d40ae9c749944$var$showAllLinks = document.querySelectorAll(".block-downloads .show-all");
if ($5a8d40ae9c749944$var$showAllLinks) $5a8d40ae9c749944$var$showAllLinks.forEach((showAllLink)=>{
    showAllLink.addEventListener("click", function(event) {
        event.preventDefault();
        const thisLink = event.target;
        const block = thisLink.closest(".block-downloads");
        if (block.classList.contains("is-showing-all")) {
            block.classList.remove("is-showing-all");
            thisLink.textContent = thisLink.getAttribute("data-button-text");
        } else {
            thisLink.setAttribute("data-button-text", thisLink.textContent);
            thisLink.textContent = "Show less";
            block.classList.add("is-showing-all");
        }
    });
});

});


parcelRequire("7M0iY");
})();
//# sourceMappingURL=block-downloads.js.map
